import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {setActiveTabs} from '../../../../../../../app/top-tabs-reduser';
import {useAppSelector} from '../../../../../../../common/hook';
import {ROLE_DEMO_STUDENT, ROLE_STUDENT} from "../../../../../../../entities/constants/constants";

SwiperCore.use([Navigation, Pagination]);

export const TestStudentTabs = () => {
    const dispatch = useDispatch();
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const swiperRef = useRef<SwiperCore | null>(null);
    const roleType = useAppSelector((state) => state.role.roleType);

    const tabs = [
        ...(roleType && roleType !== 'student' && roleType !== 'student-demo'
            ? [
                { id: 0, label: 'Тест' },
                { id: 1, label: 'Студенты' },
            ]
            : []),
    ];



    const handleTabClick = (index: number) => {
        // Check if the clicked tab is already active
        if (activeTabs.includes(index)) {
            return;
        }

        const newActiveTabs = [index];
        dispatch(setActiveTabs(newActiveTabs));
        swiperRef.current?.slideTo(newActiveTabs[0]);
    };


    useEffect(() => {
        return () => {
            // Сброс активного таба при размонтировании компонента
            dispatch(setActiveTabs([0]));
        };
    }, [dispatch]);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.on('slideChange', () => {
                dispatch(setActiveTabs([swiperRef.current?.activeIndex ?? 0]));
            });
        }
    }, [dispatch]);

    return (
        <Swiper
            slidesPerView={'auto'}
            loop={false}
            spaceBetween={0}
            watchOverflow={true}
            className="tabs-nav"
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
        >
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {tabs.map((tab) => (
                        <SwiperSlide
                            key={tab.id}
                            className={`swiper-slide ${activeTabs.includes(tab.id) ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
              <span className={`tab-nav-item ${activeTabs.includes(tab.id) ? 'active' : ''}`}>
                {tab.label}
              </span>
                        </SwiperSlide>
                    ))}
                </div>
            </div>
            {tabs.map((tab) => (
                activeTabs.includes(tab.id) && (
                    <div key={tab.id} className={`tab-content ${activeTabs.includes(tab.id) ? 'active' : ''}`}/>
                )
            ))}
        </Swiper>
    );
};
